module.exports = __webpack_public_path__ + "img/eye-in-office.b5c25eed.webp";